import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { StateTag, Tag } from "@msuite/ui/tag";
import { getAbsenceCategoryTranslationKey } from "@msuite/utils/absences";
import { getColorByString } from "@msuite/utils/colors";
import { moment } from "@msuite/utils/date";
import type { SubstitutionPlanDetailSchema } from "@msuite/utils/schemas";
import type { Nullable } from "@msuite/utils/types";
import { getFullName } from "@msuite/utils/users";

/** Props Interface */
export interface SubstitutionHeaderProps {
	substitutionPlan: Nullable<SubstitutionPlanDetailSchema>;
}

export function SubstitutionHeader({ substitutionPlan }: SubstitutionHeaderProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!substitutionPlan) return null;

	/** Render */
	return (
		<ContentCard
			icon={icon("User")}
			title={getFullName(substitutionPlan)}
			identifier={substitutionPlan.id}
		>
			<div className="justify-between h-stack">
				<Tag
					variant="plain"
					color={getColorByString(substitutionPlan.category)}
				>
					{t(getAbsenceCategoryTranslationKey(substitutionPlan.category))}
				</Tag>
				<div className="h-stack gap-6">
					<p className="tabular-nums">
						{moment(substitutionPlan.startDate).dateFormat()} -{" "}
						{moment(substitutionPlan.endDate).dateFormat()}
					</p>
					<StateTag state={substitutionPlan.state} />
				</div>
			</div>
		</ContentCard>
	);
}
